import React, { Component } from "react"

import { CCard, CCardBody, CCardTitle } from "@coreui/react"
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"

export class UserTournamentsData extends Component {
	constructor(props) {
		super(props)
		this.state = {}
	}

	render() {
		return (
			<CCard>
				<CCardBody>
					<CCardTitle>Torneos</CCardTitle>

					<Stack direction="row" spacing={2}>
						<EmojiEventsIcon fontSize="small" />
						<Typography variant="body2" color="text.secondary">
							Torneos: {this.props.num_torneos ? this.props.num_torneos : "0"}
						</Typography>
					</Stack>
				</CCardBody>
			</CCard>
		)
	}
}

export default UserTournamentsData
